import React, { Component } from 'react';
import './App.css';
import 'bootstrap-css-only';
import axios from 'axios';
import {FMJD_CORE_GET_GAMES_SCRIPT, 
        FMJD_CORE_GET_SETTINGS_SCRIPT,
        FMJD_TOURNAMENTS_URL,
        GAMES_VIEWER_URL
        } from './board/Constans';
import GamesContainer from './GamesContainer';
import is from "is_js"
import { hashCode } from './tools';

import {
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
    } from 'reactstrap';

export default class RoundGames extends Component {
    constructor(props) {
        super(props);
        this.state = {
            settingsData: {
                commentsEnable:"1",
                pdnButtonEnable:"1",
                movesListEnable:"1",
                isGameEditUserLogin:false,
                isCommentEditUserLogin:false,
                subgames:"0",
            },
            showGamesContainer: false,
            gamesData: [],
        }
        this._reloadSettings = this._reloadSettings.bind(this);
        const dapTournamentKey = this.props.match.params.tourn;
        const round = this.props.match.params.round;
        
        this.getGamesUrl = FMJD_CORE_GET_GAMES_SCRIPT + "?dapTournamentKey=" + dapTournamentKey + "&round=" +round;
    }
    
    componentDidMount() {
       this._loadData();
    }

    async _loadData() {
        await this._reloadSettings();
        this.getGames();
    }

    async _reloadSettings() {
        const pwdData = JSON.parse(localStorage.getItem('gep_dap') || '{}');
        let pwd = '';
        if (this.props.match !== undefined && this.props.match.params !== undefined && this.props.match.params.tourn !== undefined) {
            pwd = pwdData[this.props.match.params.tourn];
        }
        const urlSettings = FMJD_CORE_GET_SETTINGS_SCRIPT + "?dapTournamentKey=" + this.props.match.params.tourn + '&localPwd=' + encodeURIComponent(btoa(pwd));
        this.mounted = true;

        return axios.get(urlSettings, { withCredentials:false })
            .then(res => {
                if ( !this.mounted ) return;
                const settingsData = res.data;
                console.log(settingsData);
                if (Array.isArray(settingsData) && settingsData.length > 0) {
                    this.setState({ settingsData: {
                        ...settingsData[0],
                        reloadSettings: this._reloadSettings.bind(this)
                    }});
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    async getGames() {
        return axios.get(this.getGamesUrl)
            .then(res => {
                const gamesData = res.data;
                if ( !this.mounted ) return;
                if (Array.isArray(gamesData)) {
                    this._decodeHTMLEntities(gamesData)
                    this.setState({ 
                        gamesData:gamesData,
                        showGamesContainer: true
                    });
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    _decodeHTMLEntities(gamesData) {
        let element = document.createElement('div');  
        gamesData.forEach(game=>{
            Object.keys(game).forEach(key=>{
                let value = game[key];
                if(value && typeof value === 'string') {
                    // strip script/html tags
                    value = value.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                    value = value.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                    element.innerHTML = value;
                    value = element.textContent;
                    element.textContent = '';
                    game[key] = value;
                }
            })
        }) 
        
    }
  
    

    componentWillUnmount() {
        this.mounted = false;
    }

    getNavbarClubsItems() {
        const clubs = [];
        this.state.gamesData.forEach((game) => {
            if (!clubs.includes(game.whiteClub)) {
                clubs.push(game.whiteClub);
            }
            if (!clubs.includes(game.blackClub)) {
                clubs.push(game.blackClub);
            }
        })
        let selectedClub = 'Select team/club';
        let clubsItems = clubs.map((club, idx) =>{
            const hashClub = hashCode(club);
            const clubURL = `${GAMES_VIEWER_URL + this.props.match.params.tourn}/${this.props.match.params.round}/${this.props.match.params.rounds}/false/${hashClub}`;
            if (this.props.match.params.club == hashClub) {
                selectedClub = club;
            }
            const res =
                <DropdownItem key={"club" + (idx+1)} >
                <NavItem>
                    <NavLink href={clubURL}>{club}</NavLink>
                </NavItem>
                </DropdownItem>
            return res;
        });

        clubsItems = [
            <DropdownItem key={"club0"} >
            <NavItem>
                <NavLink href={`${GAMES_VIEWER_URL + this.props.match.params.tourn}/${this.props.match.params.round}`}>All</NavLink>
            </NavItem>
            </DropdownItem>,
            ...clubsItems];
        const result =
            <UncontrolledDropdown key="tournamentRounds" nav inNavbar>
            <DropdownToggle nav caret>
                [{selectedClub}]
            </DropdownToggle>
            <DropdownMenu right>
                <DropdownItem divider />
                {clubsItems}
            </DropdownMenu>
            </UncontrolledDropdown>;
        return result;
    }
    
    getNavbarItems(tournamentRound) {
        let tournRounds = "";
        if (!this.props.match.params.rounds || is.ie()) {
            const roundURL = GAMES_VIEWER_URL + this.props.match.params.tourn + "/" + this.props.match.params.round;
            tournRounds = <NavItem>
                          <NavLink href={roundURL}>[Round {tournamentRound}]</NavLink>
                         </NavItem>
        } else {
            let roundsItems = [];
            for (let i = 1; i <= this.props.match.params.rounds; i++) {
                const roundURL = GAMES_VIEWER_URL + this.props.match.params.tourn + "/" + i + "/" + this.props.match.params.rounds;
                roundsItems.push(
                    <DropdownItem key={"rnd" + i} >
                        <NavItem>
                        <NavLink href={roundURL} target="_blank">Round {i}</NavLink>
                        </NavItem>
                    </DropdownItem>
                )
            }
            tournRounds = 
                        <UncontrolledDropdown key="tournamentRounds" nav inNavbar>
                            <DropdownToggle nav caret>
                                [Round {tournamentRound}]
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem divider />
                                {roundsItems}
                            </DropdownMenu>
                        </UncontrolledDropdown> 
            
        }
     
        return tournRounds;
    }

    render() {
        let tournamentName = "";
        let tournamentSite = "";
        let tournamentRound = "";


        if (this.state.gamesData) {
            for(let i = this.state.gamesData.length-1; i >= 0 ; i--) {
                const game = this.state.gamesData[i];
                tournamentName = game.event;
                tournamentSite = game.site;
                tournamentRound = game.round;
            }
        }

        const gamesData = this.state.gamesData.sort((a, b) => {
            const pairA = a.pairNo * 1;
            const pairB = b.pairNo * 1;
            if (pairA > pairB) {
                return -1;
            } else if (pairA < pairB) {
                return 1;
            }
            return 0;
        })

        const turnamentUrl = FMJD_TOURNAMENTS_URL + this.props.match.params.tourn.replace('[@SL]', '/') + "/";
        const gamesCnt = this.state.showGamesContainer ? 
            <GamesContainer
                selectedClub={this.props.match ? this.props.match.params.club : null}
                getGamesUrl={this.getGamesUrl}
                navbarItems={[this.getNavbarItems(tournamentRound)]}
                navbarClubItems={[this.getNavbarClubsItems()]}
                showGamesOnlyWithMoves={this.props.match.params.onlyWithMoves === "true"}
                gamesData={gamesData}
                settingsData={this.state.settingsData}
                header={tournamentName+" ["+tournamentSite+"]"}
                headerLink={turnamentUrl}
            >
            </GamesContainer>
            : null;

        return (
            gamesCnt
        )
  }
}




// WEBPACK FOOTER //
// ./src/RoundGames.js